module.exports = __webpack_public_path__ + "04_medium_brown.b51e2a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_medium_brown.png
// module id = tgK+
// module chunks = 0